var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C6.2473 2 4 4.2473 4 7V25C4 27.7527 6.2473 30 9 30H27C27.5523 29.9999 27.9999 29.5523 28 29V7C27.9999 6.44774 27.5523 6.00006 27 6H24V3C23.9999 2.44774 23.5523 2.00006 23 2H9ZM24 8H26V28H9C7.3207 28 6 26.6793 6 25C6 23.3207 7.3207 22 9 22H23C23.5523 21.9999 23.9999 21.5523 24 21V8Z",
    fill: "#00AC69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9721 23.9996H9.00009C7.64776 23.9805 7.64776 26.0188 9.00009 25.9996H22.9721C23.5358 26.0076 23.9946 25.5478 23.9858 24.9901C23.9768 24.4325 23.5236 23.9921 22.9721 23.9996Z",
    fill: "#00AC69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGuide);
export default __webpack_public_path__ + "static/media/user-guide.a8b8f4d76f4f92cbcc585c75e27ea82f.svg";
export { ForwardRef as ReactComponent };